import { useMemo } from 'react';
import { useCurrentModule } from '../components';
import { PERSONALIZED_CONTENT_QUERY_OPTIONS, useIsPersonalizedContentEnabled, usePersonalizedParams } from './usePersonalizedParams';
export const usePersonalizedDescriptions = () => {
  const module = useCurrentModule();
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    params,
    enabled
  } = usePersonalizedParams();
  const {
    data,
    isLoading
  } = module.SDK.personalizedDescriptionsApiClient.hooks.useGetPersonalizedDescriptions(params, enabled, PERSONALIZED_CONTENT_QUERY_OPTIONS);
  const byFamily = useMemo(() => {
    const map = new Map();
    const items = data == null ? void 0 : data.items;
    if (Array.isArray(items)) {
      items.forEach(item => map.set(item.productFamilyId, item.translation));
    }
    return map;
  }, [data]);
  return {
    getDescriptionTranslation: productFamilyId => isEnabled && productFamilyId ? byFamily.get(productFamilyId) : undefined,
    isLoading: enabled && isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedDescriptions.js.map